export const iconFontAwesomeMedicalHealthHeartPulse = (
	<i className="fa-solid fa-heart-pulse"></i>
);
